import { Injectable } from '@angular/core';
import { Converter } from '../../converter.interface';
import { isNullOrUndefined } from 'util';
import { ProcessActivityObject } from 'src/app/models/orders/order-details-process/process-details/process-activity-object.model';
import * as moment from 'moment';
import { AppService } from 'src/app/app.service';

@Injectable({
    providedIn: 'root'
})
export class OrderDetailsProcessActivitiesConverter implements Converter<Array<ProcessActivityObject>> {

    activityList: Array<ProcessActivityObject> = new Array<ProcessActivityObject>();
    activity;
    constructor(private appService: AppService) { }

    convert(input: any): Array<ProcessActivityObject> {
        if (isNullOrUndefined(input)) {
            return new Array<ProcessActivityObject>();
        }
        this.activityList = new Array<ProcessActivityObject>();
        const actualDate = moment();
        const expectedDuration = 86400000;
        for (this.activity of input.activities) {

            if (this.activity.id === 'billing' && !this.appService.settings.hasBilling) {
                continue;
            }

            const actStartDate: Date = this.activity.startTimeStamp;
            const endCompletedDate: Date = this.activity.endTimeStamp;
            const started: boolean = actStartDate != null;
            const completed: boolean = endCompletedDate != null;
            const cancelled: boolean = false;
            var duration = this.activity.duration;
            var startDate = moment(this.activity.startTimeStamp);
            var state: string = "";
            if (started) {
                state = "START";
                if (duration === 0) {
                    if (completed) {
                        var endDate = moment(this.activity.endTimeStamp);
                        duration = moment.duration(endDate.diff(startDate));
                        state = "END";
                    } else {
                        duration = moment.duration(actualDate.diff(startDate));
                        if (input.tasks && input.tasks.length > 0) {
                            state = "ERROR";
                        }
                    }
                }
            }

            this.activity = new ProcessActivityObject(this.activity.id, state, this.activity.errorList, this.activity.numErrors,
                duration.valueOf(), expectedDuration, actStartDate, endCompletedDate, this.activity.description,
                completed, this.activity.bypassed, cancelled, started);

            this.activityList.push(this.activity);
        }
        return this.activityList;
    }
}